import * as React from "react";
import { forwardRef, memo } from "react";
const SvgMc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5 4", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#FFF", d: "M0 0h5v4H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#CE1126", d: "M0 0h5v2H0z" }));
const ForwardRef = forwardRef(SvgMc);
const Memo = memo(ForwardRef);
export default Memo;
